import HeroDualImage from './HeroDualImage';

export default () => {
  // console.log('HeroDualImage initialized');

  // TEMPORARILY DISABLED INITIALIZATION DUE TO IOS CRASHING

  document.querySelectorAll('[data-hero-dual-image]').forEach((el) => {
    if (el.getAttribute('data-initialized') === 'true') {
      return;
    }

    new HeroDualImage(el);

    el.setAttribute('data-initialized', 'true');
  });
};
